module.exports = __webpack_public_path__ + "static/img/header.9d6181d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/header.png
// module id = nvbl
// module chunks = 1